import type { ReactNode } from 'react'
import { IconClose, IconWarning } from '../icons.js'

export interface AlertProps {
  children: ReactNode
  /** Без этого проп кнопка закрытия не показывается — не у каждого оповещения есть, чем управлять (см. App.tsx, meError). */
  onDismiss?: () => void
  tone?: 'danger' | 'info' | 'warn'
}

/**
 * Заметное оповещение с причиной отказа сервера (FR-ADM-006) и, когда есть
 * чем управлять, кнопкой закрытия (FR-ADM-018) — правило 3 и 5 из раздела 6
 * спецификации порталов: отказ виден и не запирает экран собой навсегда.
 *
 * Сообщение — прямой потомок `.alert__message`, а не `.alert`: кнопка
 * закрытия не добавляет текстовых узлов в тот же элемент, что и текст
 * ошибки, поэтому существующие проверки `findByText(точная строка)`
 * по-прежнему находят ровно один узел.
 */
export function Alert(props: AlertProps) {
  const { children, onDismiss, tone = 'danger' } = props
  const toneClass = tone === 'danger' ? '' : ` alert--${tone}`

  return (
    <div className={`alert${toneClass}`} role="alert">
      <IconWarning />
      <span className="alert__message">{children}</span>
      {onDismiss !== undefined && (
        <button type="button" className="alert__close" aria-label="Закрыть" onClick={onDismiss}>
          <IconClose />
        </button>
      )}
    </div>
  )
}
